import type { PricesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment';
import { atom } from 'recoil';

export const opcOldPriceAtom = atom<PricesDTO | undefined>({
    key: 'opcOldPriceAtom',
    default: undefined
});
